import type { ReactNode } from 'react';

import type { IconName } from '../../../assets/Icon/Icon';
import { Icon } from '../../../assets/Icon/Icon';
import { colors, darkThemeSelector, styled } from '../../../stitches.config';

const ChassisBracketLine = styled('div', {
  flex: 1,
  height: '$1',
  background: colors.strokeNeutralLight,
  position: 'relative',

  [darkThemeSelector]: {
    background: colors.strokeNeutralDark,
  },
});
ChassisBracketLine.displayName = 'ChassisBracketLine';

const ChassisBracketIcon = styled(Icon, {
  color: colors.accentNeutralLight,

  [darkThemeSelector]: {
    color: colors.accentNeutralDark,
  },
});
ChassisBracketIcon.displayName = 'ChassisBracketIcon';

const ChassisBracketText = styled('span', {
  whiteSpace: 'nowrap',
  color: colors.accentNeutralLight,
  fontSize: '$9',
  lineHeight: '$12',

  [darkThemeSelector]: {
    color: colors.accentNeutralDark,
  },
});
ChassisBracketText.displayName = 'ChassisBracketText';

const ChassisBracketContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$4',
});
ChassisBracketContainer.displayName = 'ChassisBracketContainer';

export type ChassisBracketProps = {
  icon?: IconName;
  label?: ReactNode;
};

export function ChassisBracket({ label, icon }: ChassisBracketProps) {
  if (!label) return null;

  return (
    <ChassisBracketContainer>
      <ChassisBracketLine />
      {icon && <ChassisBracketIcon icon={icon} size={8} />}
      <ChassisBracketText>{label}</ChassisBracketText>
      <ChassisBracketLine />
    </ChassisBracketContainer>
  );
}
